let initialState = {
  data: {
    shopId: "",
    billId: "",
    customerName: "",
    customerPhoneNumber: "",
    billingDate: new Date().toISOString().substring(0, 10),
    items: "",
    billVersion: 1,
    paymentMethod: "",
    shippingAddress: "",
    billingAddress: "",
    dueDate: "",
    employeeName: "",
    discount: "",
    discountType: "flat",
    invoiceNumber: "",
    productTotal: "",
    balanceAmount: "",
    loyaltyDiscountType: "",
    taxAmount: "",
    coupon: "",
    couponDiscountType: "",
    otherCharges: [],
    cameFrom: "NA",
    notes: "",
    extraFields: {
      wastage: false,
      labour: false,
      tax: "",
      discount: "",
      hsnCode: "",
      mrp: "",
      otherCharges: "",
    },
    remainder: "",
    tAndC: "",
    paymentTerms: "",
    invoicePrefix: "",
    invoiceTemplate: "",
    loyalty: "",
    couponDiscountAmount: "",
    loyaltyPoints: 0,
    printerType: "",
    cardType: "",
    cardNumber: "",
    taxList: "",
    amountReceived: 0,
    billAmountDue: 0,
  },
  discount: {
    itemDiscountType: "",
    billDiscountType: "",
    loyaltyDiscountType: "",
    couponDiscountType: "",
  },
  outstandingAmount: 0,
  availableLoyaltyPoints: 0,
  loyaltyPoints: 0,
};

const billingPayloadReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_BILL_PAYLOAD": {
      return action.payload;
    }
    case "SET_BILLING_PAYLOAD":
      return {
        ...state,
        data: action.payload,
      };
    case "UPDATE_PAYMENT_METHOD":
      return {
        ...state,
        data: {
          ...state.data,
          paymentMethod: action.payload,
        },
      };
    case "SET_DISCOUNT":
      return {
        ...state,
        discount: action.payload,
      };
    case "SET_LOYALTY_POINTS":
      return {
        ...state,
        data: {
          ...state.data,
          loyalty: action.payload,
        },
      };
    case "SET_COUPON":
      return {
        ...state,
        data: {
          ...state.data,
          coupon: action.payload,
        },
      };
    case "UPDATE_DISCOUNT_TYPE":
      return {
        ...state,
        data: {
          ...state.data,
          discountType: action.payload,
        },
      };
    case "UPDATE_DISCOUNT_VALUE":
      return {
        ...state,
        data: {
          ...state.data,
          discount: action.payload,
        },
      };
    case "SET_NOTES":
      return {
        ...state,
        data: {
          ...state.data,
          notes: action.payload,
        },
      };
    case "SET_ADDRESS":
      return {
        ...state,
        data: {
          ...state.data,
          shippingAddress: action.payload.shippingAddress,
          billingAddress: action.payload.billingAddress,
        },
      };
    case "SET_CARD_TYPE":
      return {
        ...state,
        data: {
          ...state.data,
          cardType: action.payload,
        },
      };
    case "SET_CARD_NUMBER":
      return {
        ...state,
        data: {
          ...state.data,
          cardNumber: action.payload,
        },
      };
    case "SET_AMOUNT_RECEIVED":
      return {
        ...state,
        data: {
          ...state.data,
          amountReceived: action.payload.amountReceived,
          billAmountDue: action.payload.due,
          balanceAmount: action.payload.due,
        },
      };
    case "SET_OTHER_CHARGES": {
      return {
        ...state,
        data: {
          ...state.data,
          otherCharges: action.payload,
        },
      };
    }
    case "CLEAR_ALL_BILLING_PAYLOAD":
      return {
        ...state,
        data: {
          ...initialState.data,
        },
      };
    case "SET_CUSTOMER_DATA": {
      return {
        ...state,
        data: {
          ...state.data,
          customerName: action.payload.customerName,
          customerPhoneNumber: action.payload.customerPhoneNumber,
          loyalty: {},
          loyaltyPoints: action.payload.loyaltyPoint,
        },
        loyaltyPoints: action.payload.loyaltyPoint,
        outstandingAmount: action.payload.outStandingAmount,
        availableLoyaltyPoints: action.payload.loyaltyPoint,
      };
    }
    case "APPLY_LOYALTY": {
      return {
        ...state,
        data: {
          ...state.data,
          loyalty: action.payload,
        },
      };
    }
    case "REMOVE_LOYALTY": {
      return {
        ...state,
        data: {
          ...state.data,
          loyalty: {},
        },
      };
    }
    case "SET_CUSTOMER_NAME":
      return {
        ...state,
        data: {
          ...state.data,
          customerName: action.payload,
        },
      };
    case "SET_CUSTOMER_PHONE": {
      return {
        ...state,
        data: {
          ...state.data,
          customerPhoneNumber: action.payload,
        },
      };
    }
    default:
      return state;
  }
};

export default billingPayloadReducer;
